import PropTypes from "prop-types";
import CloseBtn from "../CloseBtn/CloseBtn";
import CloseIcon from "../../assets/img/icons/close.svg";
import { StyledModalHeader } from "../../styles/StyledModalHeader";

export default function ModalHeader({ onClick, children }) {
	return (
		<StyledModalHeader>
			<h2 data-testid="textHeader">{children}</h2>
			<CloseBtn onClick={onClick} icon={CloseIcon} />
		</StyledModalHeader>
	);
}

ModalHeader.propTypes = {
	children: PropTypes.any,
	onClick: PropTypes.func.isRequired,
};
